export default "__VITE_ASSET__DU9JhUbO__"